import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { companyRoutes } from './lib.routes';

@NgModule({
  imports: [CommonModule, RouterModule.forChild(companyRoutes)],
})
export class CompanyModule {}
